import { Component, OnInit, ViewChild } from '@angular/core';
import { GceManagementService } from '../../services/gce-management.service';
import { FormComponent } from '../../shared/form/form.component';
import { DatatableComponent } from '../../shared/datatable/datatable.component';
import { FormHeaderComponent, ICustomButton, IFormHeaderSearch, FormHeaderSearchEventsEnum } from '../../shared/form-header/form-header.component';
import { MatDialog } from '@angular/material/dialog';
import { GceClinic, GceInvoicePerson, GceAnagraphic, GceMedicType, GceFiscalReg, GceProfiles, GceProvCodes, GcePrint3d, GceInvoicePersonClinic, GceInvoicePersonCompensation, GceArea } from '../../entities/gce-management';
import { IConditionalFormatting } from '../../directives/conditional-formatting.directive';
import { AlertDialogService } from '../../services/alert-dialog.service';
import { PermissionService } from '../../services/permission.service';
import { GceLookUpOptions } from '../../entities/gce-management/gce-management';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActionsService } from '../../services/actions.service';
import { ExcelService } from '../../services/excel.service';
import { Observable } from 'rxjs/Observable';
const dateFormatDate = "YYYY-MM-DD";

@Component({
  selector: 'app-gce-print3d',
  templateUrl: './gce-print3d.component.html',
  styleUrls: ['./gce-print3d.component.css']
})

export class GcePrint3dComponent implements OnInit {
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;
  @ViewChild('formData', { static: false }) formData: FormComponent;
  @ViewChild('formHeader', { static: false }) formHeader: FormHeaderComponent;

  columns: any[] = [];
  clinics: any[] = [];
  personal: any[] = [];
  personalBkp: any[] = [];
  personsclinics: GceInvoicePersonClinic[] = [];
  personscompensations: GceInvoicePersonCompensation[] = [];
  fromDate: string = this.gceService.dataRepoGceEnvironment.getFromDate();
  toDate: string = this.gceService.dataRepoGceEnvironment.getToDate();
  limitRows: number;
  heightMainList: number;
  openRightPanel: boolean = false;
  currentRow: any;
  editing: boolean = false;
  newRow: boolean = false;
  keyColumn: any = {};
  modal;
  relationTable;
  showb: boolean = false;

  conditionalFormattingConfig: IConditionalFormatting;

  customButtons: ICustomButton[] = [];

  constructor(private dialog: MatDialog, private gceService: GceManagementService, private alertDialog: AlertDialogService, private permissionService: PermissionService,
    private translateService: TranslateService, private actionsService: ActionsService, private excelService: ExcelService) {
    this.customButtons.push({
      matTooltipCode: 'GCE.GCEINVOICEPERSON.BUTTONS.EXPORTTOEXCEL.TOOLTIP',
      labelCode: 'GCE.GCEINVOICEPERSON.BUTTONS.EXPORTTOEXCEL.LABEL',
      img: 'assets/img/excel.png',
      class: 'custom-button',
      clickFunction: this.exportToExcel.bind(this)
    });
    this.customButtons.push({
      matTooltipCode: 'AMM.BTN.LBL.SAVE',
      labelCode: 'AMM.BTN.LBL.SAVE',
      img: 'assets/img/save_b.png',
      class: 'custom-button',
      clickFunction: this.save.bind(this)
    });
    this.conditionalFormattingConfig = {
      formulas: [{
        field: 'errore',
        rule: '=== true',
        classes: ['row-danger']
      },]
    };
  }

  ngOnInit() {
    this.showb = true;
    this.limitRows = Math.floor((window.innerHeight - 269) / 31); //269 340
    this.heightMainList = window.innerHeight - 188; //188 259
    this.columns = GcePrint3d.getStructure();
    console.log(' GcePrint3d.getStructure() %o', this.columns);

    this.gceService.loadMedics().subscribe(md => {

      this.gceService.dataRepoMedics = md;
      this.columns.forEach(column => {
        if (column.primaryKey) {
          this.keyColumn = column;
        }
        if (column.reference) {
          let lookUpOptions: GceLookUpOptions;
          if (column.reference.entity == "GceMedics") {
            let opt = [];
            for (let o = 0; o < md.length; o++) {
              // console.log('md %o',md[o]);
              opt.push({ key: md[o].idfatturazione, value: md[o].idfatturazione + ' - ' + md[o].descrizione });
            }
            opt.push({ key: null, value: null });
            lookUpOptions = { lookUp: {}, options: opt };
          }
          if (lookUpOptions) {
            column.lookUp = lookUpOptions.lookUp;
            column.options = lookUpOptions.options;
          }
        }
      });
    });
    this.personalBkp = [];

    this.gceService.getAllClinics().subscribe((clinics: GceClinic[]) => {
      this.gceService.dataRepoClinics = clinics;
      this.gceService.getPrint3dFromTo(this.fromDate, this.toDate).subscribe(c => {
        this.showb = false;
        this.personalBkp = this.personal;
        this.personal = [];
        for (let a = 0; a < c.length; a++) {
          c[a]['touched'] = false;
          this.personal.push(c[a]);
        }
        this.personal = [...this.personal];
      });
    });
  }

  onSearch(searchFilter: any) {
    console.log("onSearch %o", searchFilter);
    this.personal = this.personalBkp.filter(item => {
      for (let key in item) {
        if (item[key] != null && item[key] != undefined && item[key].toString().toLowerCase().indexOf(searchFilter.filter) >= 0)
          return true;
      }
      return false;
    });
    this.table.offset = 0;

    if (searchFilter.event === FormHeaderSearchEventsEnum.FROM_CHANGE) {
      let mfd = moment(searchFilter.fromDate);
      let mtd = moment(searchFilter.toDate);
      this.fromDate = mfd.format(dateFormatDate);
      if (mtd.diff(mfd, 'days') > mfd.daysInMonth() || mtd.isBefore(mfd)) {
        this.toDate = mfd.endOf('month').format(dateFormatDate);
      }
    }
    if (searchFilter.event === FormHeaderSearchEventsEnum.TO_CHANGE) {
      let mfd = moment(searchFilter.fromDate);
      let mtd = moment(searchFilter.toDate);
      this.toDate = mtd.format(dateFormatDate);
      if (mtd.diff(mfd, 'days') > mtd.daysInMonth() || mtd.isBefore(mfd)) {
        this.fromDate = mtd.startOf('month').format(dateFormatDate);
      }
    }
    if (this.fromDate && this.toDate&&this.toDate>=this.fromDate) {
      this.showb = true;
      this.gceService.getPrint3dFromTo(this.fromDate, this.toDate).subscribe(c => {
        this.showb = false;
        this.personalBkp = this.personal;
        this.personal = [];
        for (let a = 0; a < c.length; a++) {
          c[a]['touched'] = false;
          this.personal.push(c[a]);
        }

        this.personal = [...this.personal];
      });
    }
  }

  onToggle(selectedColumns) {
    console.log('onToggle %o', selectedColumns);
  }

  onChangeRow(row) {
    console.log('onChangeRow %o', row);
    row['touched'] = true;
  }

  onRestore(event) {

  }

  onSave(event) {

  }


  delay = ms => new Promise(res => setTimeout(res, ms));


  onDelete(person: GceInvoicePerson) {
    console.log("onDelete %o", person);

  }

  onAction(event) {
    console.log("onAction %o", event);
  }

  onCloseForm(event) {
    console.log("onCloseForm %o", event);
    this.clear();
  }

  onCustomActionClick(args) {
    console.log("onCustomActionClick %o", args);
  }

  checkPerson(person: GceInvoicePerson) {
    this.gceService.checkPerson(person).subscribe(response => {
      console.log("checkPerson response %o", response);
    })
  }

  clear() {
    this.editing = false;
    this.newRow = false;
    this.openRightPanel = false;
  }

  exportToExcel() {
    let fileName = `${this.translateService.instant('AMM.GCE.PRINT3D').replace(' ', '_')}_${moment().format('YYYYMMDD')}`;
    this.excelService.exportAsExcelFile(this.personal, fileName);
  }

  save() {
    let arrayCall = [];
    this.showb = true;
    for (let a = 0; a < this.personal.length; a++) {
      if (this.personal[a]['touched'] == true) {

        let ret = this.gceService.updatePrint3d(this.personal[a]['PreventivoPrestazioneId'], this.personal[a]['idfatturazione']);
        arrayCall.push(ret);
      }
    }
    let self = this;

    Observable.forkJoin(arrayCall).subscribe(results => {
      console.log('results %o', results);
      self.showb = false;
    }, err => {
      self.showb = false;
    });
  }
}
